import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validador para verificar si dos contraseñas coinciden.
 *
 * Este validador personalizado debe aplicarse a un `FormGroup` que contenga
 * los campos `newPassword` y `confirmNewPassword`. Retorna un error `{ passwordMismatch: true }`
 * si los valores de ambos campos no son iguales.
 *
 * @returns Un `ValidatorFn` que valida la coincidencia de las contraseñas.
 */
export function passwordMatchValidator(
  passwordControlName: string,
  confirmPasswordControlName: string
): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const password = formGroup.get(passwordControlName);
    const confirmPassword = formGroup.get(confirmPasswordControlName);

    if (!password || !confirmPassword) {
      return null;
    }

    if (!password.value || !confirmPassword.value) {
      return null;
    }

    if (password.value !== confirmPassword.value) {
      const error = { passwordMismatch: true };
      confirmPassword.setErrors(error);
      return error;
    }

    confirmPassword.setErrors(null);
    return null;
  };
}
